import { OnInit, Component } from '@angular/core';

@Component({
    selector: 'digital-advice-landing',
    template: ''
})

export class DigitalAdviceComponent implements OnInit {
    constructor() {
    }

    ngOnInit() {
      this.openNewloaction();
    }
    openNewloaction() {
            window.location.href = '/c/portal/saml2new/websso?SSOIndicator=NXI_SSOOUT_IDPINIT_MARSTONE';
    }
}
